import { useEffect, useRef, useState } from "react";
import "../App.css";
import { toast } from "react-toastify";
import { AddCircleOutlineRounded } from "@mui/icons-material";
import "./Section.css";
import { TextField } from "@mui/material";
import { API } from "../assets/staticData";
import NewsletterDataTable from "../components/data-tables/NewsletterDataTable";

let userToken = localStorage.getItem("userToken");

const headers = {
  Authorization: `Bearer ${userToken}`,
  "Content-Type": "application/json",
};

export default function Newsletter({ user }) {
  const [error, setError] = useState(null);
  const [items, setItems] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [data, setData] = useState({
    email: "",
  });

  useEffect(() => {
    async function getData() {
      fetch(`${API}/newsletters`, {
        headers,
        method: "GET",
      }).then(async (res) => {
        const respone = await res.json();
        setItems(respone.data);
      });
    }

    getData();
  }, [refresh]);

  if (error) {
    // Print errors if any
    return <div>An error occured: {error.message}</div>;
  }

  const handleBannerDataChange = (field, value) => {
    setData({
      ...data,
      [field]: value,
    });
  };

  const uploadData = async () => {
    if (data.email !== "") {
      try {
        const response = await fetch(`${API}/newsletters`, {
          headers,
          method: "POST",
          body: JSON.stringify({
            data: data,
          }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          if (
            response.status === 400 &&
            errorData.error?.message === "This attribute must be unique"
          ) {
            toast("This email is already subscribed to the Newsletter", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "error",
            });
          } else {
            throw new Error("An unexpected error occurred");
          }
        } else {
          setData({ email: "" });
          toast("You have subscribed successfully", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "success",
          });
        }
      } catch (err) {
        toast(err.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          type: "error",
        });
      }
    } else {
      toast("Please fill the required fields", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
    }
  };

  return (
    <div className="App">
      <div>
        <h3 style={{ textAlign: "start", marginBottom: 10 }}>Newsletter Settings</h3>
        {user.perms[31].add && (
          <div className="addC" style={{ height: openAdd ? 300 : 50, padding: openAdd ? 20 : 0 }}>
            {openAdd && (
              <div
                className="addContent"
                style={{
                  marginTop: 10,
                  marginBottom: 20,
                  display: "flex",
                  width: "80%",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <TextField
                  label="Email"
                  sx={{ width: 400, mt: 2 }}
                  value={data.email}
                  onChange={(e) => handleBannerDataChange("email", e.target.value)}
                />
              </div>
            )}
            <div
              className="addBTN"
              onClick={() => (openAdd ? uploadData() : setOpenAdd(true))}
              style={{ width: openAdd ? "50%" : "100%" }}>
              Add a new Newsletter entry
              <AddCircleOutlineRounded style={{ marginLeft: 7 }} />
            </div>
            {openAdd && (
              <div
                onClick={() => {
                  setOpenAdd(false);
                }}
                className="cancelBTN">
                Cancel
              </div>
            )}
          </div>
        )}
        <NewsletterDataTable
          data={items}
          user={user}
          endpoint={"newsletters"}
          setRefresh={setRefresh}
          refresh={refresh}
          permNumber={31}
        />
      </div>
    </div>
  );
}
